module.exports = __webpack_public_path__ + "static/media/99.2fcc5ab4.png";